module.exports = __webpack_public_path__ + "img/kefu.deda3770.png";